import React from 'react';

export const Line = () => (
  <div
    style={{
      width: "100%",
      height: "1px",
      backgroundColor: "black",
      marginBottom: "25px",
      marginTop: "15px",
    }}
  />
);
